import React from 'react';
import { func, bool, string, node } from 'prop-types';
import classNames from 'classnames';

import css from './AmenityPill.module.css';

const AmenityPill = props => {
  const { amenity, isSelected, icon, label, onClick, className, rootClassName } = props;

  const classes = classNames(rootClassName || css.root, className, {
    [css.selected]: isSelected,
    [css.unselected]: !isSelected,
  });

  const iconContent = React.isValidElement(icon)
    ? icon
    : icon
    ? <img src={icon} alt="" className={css.amenityIcon} />
    : null;

  return (
    <button type="button" className={classes} onClick={onClick}>
      {iconContent && <span className={css.icon}>{iconContent}</span>}
      <span className={css.label}>{label}</span>
    </button>
  );
};

AmenityPill.defaultProps = {
  isSelected: false,
  icon: null,
  className: null,
  rootClassName: null,
  amenity: null,
};

AmenityPill.propTypes = {
  amenity: node,
  isSelected: bool,
  icon: node,
  label: string.isRequired,
  onClick: func.isRequired,
  className: string,
  rootClassName: string,
};

export default AmenityPill;
